import criticalLogger from './criticalLogger';

class CriticalErrorHandler {
  static init() {
    // Only handle unhandled JavaScript errors (critical)
    window.addEventListener('error', (event) => {
      // Only log if it's a critical error (not minor console warnings)
      if (event.error && event.error.stack) {
        criticalLogger.critical('Unhandled JavaScript Error', {
          error_message: event.message,
          error_filename: event.filename,
          error_lineno: event.lineno,
          error_colno: event.colno,
          error_stack: event.error.stack,
          error_type: 'javascript'
        });
      }
    });

    // Only handle unhandled promise rejections (critical)
    window.addEventListener('unhandledrejection', (event) => {
      criticalLogger.critical('Unhandled Promise Rejection', {
        reason: event.reason?.toString() || 'Unknown reason',
        stack: event.reason?.stack,
        error_type: 'promise_rejection'
      });
    });
  }

  // Method to manually report critical errors
  static reportCritical(error, context = {}) {
    criticalLogger.critical('Manual Critical Error Report', {
      error_name: error.name,
      error_message: error.message,
      error_stack: error.stack,
      context: context,
      error_type: 'manual'
    });
  }

  // Method to report payment errors
  static reportPaymentError(error, orderData = {}) {
    criticalLogger.paymentError(error.message || 'Payment processing failed', {
      error_name: error.name,
      error_stack: error.stack,
      order_data: orderData
    });
  }

  // Method to report API errors
  static reportApiError(endpoint, error, requestData = {}) {
    criticalLogger.apiError(endpoint, error, {
      request_data: requestData,
      status_code: error.response?.status,
      response_data: error.response?.data
    });
  }

  // Method to report form errors
  static reportFormError(formName, error, formData = {}) {
    criticalLogger.formError(formName, error, {
      form_data: formData
    });
  }

  // Method to report authentication errors
  static reportAuthError(error, context = {}) {
    criticalLogger.authError(error.message || 'Authentication failed', {
      error_name: error.name,
      error_stack: error.stack,
      context: context
    });
  }

  // Method to report payment success events (for tracking)
  static reportPaymentSuccess(paymentData = {}) {
    criticalLogger.paymentSuccess('Payment Gateway Success', paymentData);
  }

  // Method to report payment status checks (for monitoring)
  static reportPaymentStatusCheck(message, statusData = {}) {
    criticalLogger.paymentStatusCheck(message, statusData);
  }

  // Method to report payment gateway events (for monitoring)
  static reportPaymentGateway(message, gatewayData = {}) {
    criticalLogger.paymentGateway(message, gatewayData);
  }
}

export default CriticalErrorHandler;